import { render, staticRenderFns } from "./bs-label.vue?vue&type=template&id=336ad1a6&scoped=true&"
import script from "./bs-label.vue?vue&type=script&lang=ts&"
export * from "./bs-label.vue?vue&type=script&lang=ts&"
import style0 from "./bs-label.vue?vue&type=style&index=0&id=336ad1a6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "336ad1a6",
  null
  
)

export default component.exports